export { default as PricingContainer } from './containers/PricingContainer';



// WEBPACK FOOTER //
// ./src/Onboarding/Registration/onboarding/containers/Pricing/index.js